import http from "@/plugins/http";

export default {
  async getUserProfile() {
    return await http.get("/api/users/me");
  },
  async saveUserProfile(profile) {
    return await http.put(`/api/users/profile`, profile);
  },
  async sendTestAlert(data) {
    return await http.post(`/api/sites/test_alert`, data);
  },
};
